/**
 * Game information registry
 *
 * Central source of truth for available games in Memodiez.
 * Each game entry defines routing, assets, and i18n keys.
 *
 * Structure:
 * - id: Unique identifier (used for keys and routing)
 * - route: URL segment for navigation (e.g., /:lang/memorama)
 * - image: Path to game thumbnail (relative to /public)
 * - titleKey: i18n key for game name (from navigation namespace)
 * - fallbackImage: Path to fallback image if primary fails
 *
 * Usage:
 * - GameGallery component for rendering cards
 * - Navigation logic for route generation
 * - Future: filtering, categorization, metadata
 *
 * @constant {Array<Object>}
 */
export const GAMES_INFO = [
  {
    id: 'memorama',
    route: 'memorama',
    image: '/games/memorama.webp',
    titleKey: 'core.navigation.memorama',
    fallbackImage: '/games/game-fallback.webp'
  },
  {
    id: 'puzzle',
    route: 'puzzle',
    image: '/games/puzzle.webp',
    titleKey: 'core.navigation.puzzle',
    fallbackImage: '/games/game-fallback.webp'
  }
]

/**
 * Get game by ID
 *
 * @param {string} gameId - Game identifier
 * @returns {Object|undefined} Game object or undefined if not found
 */
export function getGameById (gameId) {
  return GAMES_INFO.find(game => game.id === gameId)
}

/**
 * Get total number of games
 *
 * @returns {number} Total games count
 */
export function getGamesCount () {
  return GAMES_INFO.length
}
